import Vue from 'vue';

export async function update_token(): Promise<string> {
  await Vue.keycloak_instance.updateToken(70);
  return Vue.keycloak_instance.token as string;
}
